<template>
    <ModalConfirm
        id="modal-confirm-export-laporan-ec-kas-kecil"
        title="Konfirmasi Export Laporan EC"
        desc="Apakah Anda yakin ingin export laporan EC kas kecil ini?"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-export-ec-confirm",
    props: {
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
